import React from "react";
import {
  WithStyles,
  withStyles,
  Container,
  createStyles,
  Link,
  List,
  ListItem,
} from "@material-ui/core";
import { InferProps } from "prop-types";
import Typography from "../../shared/components/Typography";
import Page from "../../shared/components/Page";
import SiteFooter from "../../shared/views/SiteFooter";
import { Link as RouterLink } from "react-router-dom";
import ScrollToTopOnMount from "../../shared/components/ScrollToTopOnMount";
import { h5 } from "../../shared/styles";
import StayInTouch from "../../shared/views/StayInTouch";

const styles = (theme: any) =>
  createStyles({
    ...h5(theme),
    root: {
      backgroundColor: theme.palette.background.default,
      minHeight: "100%",
      paddingTop: theme.spacing(15),
      [theme.breakpoints.down("sm")]: {
        paddingTop: theme.spacing(8),
      },
    },
    container: {
      marginBottom: theme.spacing(0),
      [theme.breakpoints.down("sm")]: {
        marginBottom: theme.spacing(5),
      },
      position: "relative",
      display: "flex",
      flexDirection: "column",
    },
    titleText: {
      marginBottom: theme.spacing(5),
    },
  });

function Resources(props: WithStyles<typeof styles>) {
  const { classes } = props;

  return (
    <Page className={classes.root} title="Resources &mdash; Web Field Guide">
      <ScrollToTopOnMount />
      <Container className={classes.container} maxWidth="md">
        <Typography
          className={classes.titleText}
          variant="h3"
          gutterBottom
          marked="center"
          align="center"
        >
          Resources
        </Typography>
        <Typography variant="h2" className={classes.h5} align="left">
          <Link
            href="https://github.com/rothbart/onepirate-typescript"
            key="onepirate-typescript"
            underline="always"
          >
            Onepirate + typescript
          </Link>
        </Typography>
        <Typography variant="h5">
          If you're building with React and Material-UI (which I highly
          recommend) using a{" "}
          <Link
            href="https://material-ui.com/store"
            key="template"
            underline="always"
          >
            template
          </Link>{" "}
          can give you a quick head start in getting your web app styled. One of
          the better free templates is{" "}
          <Link
            href="https://material-ui.com/store/items/onepirate/"
            key="onepirate"
            underline="always"
          >
            onepirate
          </Link>{" "}
          but unfortunately it isn't built in Typescript. In order to save you a
          bit of time I decided to{" "}
          <Link
            href="https://github.com/rothbart/onepirate-typescript"
            key="onepirate-typescript2"
            underline="always"
          >
            open source my own implementation of onepirate
          </Link>{" "}
          in Typescript, which I created while developing this guide.
        </Typography>
        <Typography variant="h2" className={classes.h5} align="left">
          <Link
            href="https://material-ui.com/guides/typescript/"
            key="mui-typescript"
            underline="always"
          >
            Material-UI + Typescript
          </Link>
        </Typography>
        <Typography variant="h5">
          An{" "}
          <Link
            href="https://material-ui.com/guides/typescript/"
            key="mui-typescript2"
            underline="always"
          >
            essential resource
          </Link>{" "}
          to help resolve some of the gotchas that you'll probably run across
          while building with Material-UI and Typescript.
        </Typography>
      </Container>
      <StayInTouch />
      <SiteFooter />
    </Page>
  );
}

export default withStyles(styles)(Resources);
